import React, { useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import ImageWithDescription from '../../components/ImageAndText/ImageWithDescription';
import image from '../../imgs/image4.png'
import Step3Form from '../notarialization/Forms/Step3Form';
import CustomAccordion from '../../components/Accordion/Accordion';

const Solution3 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const accordionBusinessItems = [
        { title: 'What is blockchain technology and how does it work in this system?', content: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.' },
        { title: 'How is data recorded and verified on the blockchain?', content: 'Content for Accordion 2' },
        { title: 'How is data confidentiality ensured in this system?', content: 'Content for Accordion 3' },
        { title: 'How is data confidentiality ensured in this system?', content: 'Content for Accordion 4' },
    ];

    const accordionTechniquesItems = [
        { title: 'What is blockchain technology and how does it work in this system?', content: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.' },
        { title: 'How is data recorded and verified on the blockchain?', content: 'Content for Accordion 2' },
        { title: 'How is data confidentiality ensured in this system?', content: 'Content for Accordion 3' },
        { title: 'How is data confidentiality ensured in this system?', content: 'Content for Accordion 4' },
    ];

    return (
        <div className='esg-wrapper notarialization-wrapper'>
            <Header text="Service de notarisation" />
            <ImageWithDescription 
                imageSrc={image} 
                imageAlt="Image Information"
                description={[
                    "Un exemple concret de l'utilité de la blockchain dans la notarisation est la gestion des actes de propriété immobilière. Grâce à la blockchain, vous pouvez enregistrer chaque acte de vente de manière immuable, garantissant ainsi que toutes les parties peuvent vérifier l'authenticité et la date de la transaction à tout moment. Lorsqu'un acte de propriété est inscrit dans la blockchain, il devient impossible de le falsifier, offrant une sécurité juridique accrue aux acheteurs et aux vendeurs. En cas de litige, la blockchain fournit une preuve irréfutable de la transaction, simplifiant les procédures judiciaires et renforçant la confiance dans le système de gestion des titres de propriété.",
                ]}
            />
            <div className='container'>
                <div className='steps-info'>
                    <h3 className='step-title'>Étape 3 sur 3</h3>
                    <p className='step-description'>Vous avez modifié le nom du document et vous cliquez sur le bouton voir pour afficher l’historique. Votre modification a été notariée.</p>
                </div>

                <Step3Form />

                <div className='accordians-wrapper'>
                    <div className='accordians-bussiness-main'>
                        <h3>Questions Business</h3>
                        <CustomAccordion items={accordionBusinessItems} />
                    </div>

                    <div className='accordians-techniques-main'>
                        <h3>Questions Techniques</h3>
                        <CustomAccordion items={accordionTechniquesItems} />
                    </div>
                </div>
            </div>

            <Footer/>
        </div>
    );
};

export default Solution3;
